import { Link } from "react-router-dom";
import { Phone, MessageCircle, Clock, ShieldCheck, Truck, BadgeCheck } from "lucide-react";
import { COMPANY, waLink } from "@/data/site";
import { ContactForm } from "@/components/ContactForm";

export const CTABanner = () => {
  const benefits = [
    { icon: Clock, text: "Atendimento 24 horas, todos os dias" },
    { icon: Truck, text: "Chegada em até 15 minutos" },
    { icon: ShieldCheck, text: "Serviço com garantia" },
    { icon: BadgeCheck, text: "Orçamento transparente" },
  ];
  return (
    <section className="bg-brand-black text-white relative overflow-hidden grain-overlay" data-testid="cta-banner">
      <div className="max-w-7xl mx-auto container-px py-16 grid lg:grid-cols-2 gap-12 items-center">
        <div>
          <span className="inline-flex items-center gap-2 bg-wa-green text-white text-xs font-bold uppercase tracking-wider px-3 py-1.5 rounded-full mb-5">
            <Clock className="w-4 h-4" /> Atendimento 24hs
          </span>
          <h2 className="font-display font-extrabold text-3xl sm:text-4xl leading-tight mb-6">
            Emergência com cano entupido? <br />
            <span className="text-brand-yellow">Resolvemos agora.</span>
          </h2>
          <ul className="space-y-3 mb-8">
            {benefits.map((b, i) => (
              <li key={i} className="flex items-center gap-3 text-gray-200">
                <span className="grid place-items-center w-9 h-9 rounded-md bg-brand-red shrink-0">
                  <b.icon className="w-4 h-4 text-white" />
                </span>
                <span className="font-medium">{b.text}</span>
              </li>
            ))}
          </ul>
          <div className="flex flex-col sm:flex-row gap-3">
            <a href={`tel:${COMPANY.phoneTel}`} className="btn-red" data-testid="cta-phone-btn">
              <Phone className="w-5 h-5" /> {COMPANY.phoneDisplay}
            </a>
            <a href={waLink()} target="_blank" rel="noopener noreferrer" className="btn-green" data-testid="cta-whatsapp-btn">
              <MessageCircle className="w-5 h-5" /> Chamar no WhatsApp
            </a>
          </div>
        </div>
        <div>
          <ContactForm />
        </div>
      </div>
    </section>
  );
};
